var map = {
	"./BG_0001.png": 4578,
	"./BG_0002.png": 7513,
	"./BG_0003.png": 1264,
	"./BG_0004.png": 287,
	"./BG_0005.png": 5094,
	"./BG_0006.png": 6301,
	"./BG_0007.png": 5172,
	"./BG_0008.png": 1091,
	"./BG_0009.png": 5530,
	"./BG_0010.png": 832,
	"./BG_0011.png": 2009,
	"./BG_0012.png": 1298,
	"./BG_0013.png": 9163,
	"./BG_0014.png": 7508,
	"./BG_0015.png": 3805,
	"./BG_0016.png": 2182,
	"./BG_0017.png": 2159,
	"./BG_0018.png": 9896,
	"./BG_0019.png": 4113,
	"./BG_0020.png": 5221,
	"./BG_0021.png": 5804,
	"./BG_0022.png": 6439,
	"./BG_0023.png": 3422,
	"./BG_0024.png": 9537,
	"./BG_0025.png": 1272,
	"./BG_0026.png": 5763,
	"./BG_0027.png": 554,
	"./BG_0028.png": 4621,
	"./BG_0029.png": 3492,
	"./BG_0030.png": 1866,
	"./BG_0031.png": 7091,
	"./BG_0032.png": 232,
	"./BG_0033.png": 177,
	"./BG_0034.png": 4062,
	"./BG_0035.png": 1751,
	"./BG_0036.png": 6924,
	"./BG_0037.png": 9813,
	"./BG_0038.png": 7810,
	"./BG_0039.png": 3163,
	"./BG_0040.png": 1415,
	"./BG_0041.png": 3726,
	"./BG_0042.png": 9477,
	"./BG_0043.png": 6588,
	"./BG_0044.png": 6755,
	"./BG_0045.png": 1530,
	"./BG_0046.png": 9841,
	"./BG_0047.png": 7515,
	"./BG_0048.png": 6447,
	"./BG_0049.png": 8358,
	"./BG_0050.png": 9916,
	"./BG_0051.png": 2805,
	"./BG_0052.png": 2446,
	"./BG_0053.png": 8023,
	"./BG_0054.png": 9032,
	"./BG_0055.png": 161,
	"./BG_0056.png": 5930
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5703;